// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"30eaf6b3","455":"2741f0de","977":"4f8179f1"}[chunkId] + ".chunk.js";
};